export function normalizeDateTime(value) {
  return value.length === 16
    ? `${value}:00`
    : value;
}
